import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import esESTranslations from './es-es'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
  'es-ES': esESTranslations,
}
